export const REFERRAL_FLOW = 'CLIENT_CLIENT';

export const REFERRAL_FLOW_TABS = [
  { id: 'CLIENT_CLIENT', name: 'Client to Client Referral' },
  { id: 'EMPLOYEE_CLIENT', name: 'Employee to Client Referral' },
];

/**
 * List currently returns incentive_amounts without usable amount values.
 * Hide wallet incentive copy until amounts are configured.
 */
export const HAS_WALLET_REWARDS = false;

export const OPS_ROLE_IDS = [26, 47];
export const CENTRAL_VALIDATE_ROLE_IDS = [...OPS_ROLE_IDS];
export const PAGE_ACCESS_ROLE_IDS = [...OPS_ROLE_IDS];

export const LEAD_STAGE_OPTIONS = [
  { id: 'hot', name: 'Hot' },
  { id: 'cold', name: 'Cold' },
  { id: 'converted', name: 'Converted' },
];

export const LEAD_STAGE_IDS = LEAD_STAGE_OPTIONS.map((option) => option.id);

export const SITE_TYPE_OPTIONS = [
  { id: 'B2B', name: 'B2B' },
  { id: 'B2C', name: 'B2C' },
];

export const STATUS_LABELS = {
  SUBMITTED: 'Submitted',
  SPOC_ASSIGNED: 'SPOC Assigned',
  VALID_LEAD: 'Valid Lead',
  REJECTED_LEAD: 'Rejected',
  FINAL_INCENTIVE_PENDING: 'Final Incentive Pending',
  FINAL_INCENTIVE_PAID: 'Final Incentive Paid',
  LEGACY_IMPORTED: 'Legacy Imported',
};

export const STATUS_FILTER_OPTIONS = [
  { id: '', name: 'All' },
  ...Object.entries(STATUS_LABELS).map(([id, name]) => ({ id, name })),
];

export const INITIAL_REFERRAL_FILTERS = {
  status: '',
  include_legacy: false,
};

export const FLOW_DATA_FIELD_CONFIG = [
  { key: 'property_name', heading: 'Property Name' },
  { key: 'property_type', heading: 'Property Type' },
  { key: 'referrer_name', heading: 'Referrer Name' },
  { key: 'referrer_phone', heading: 'Referrer Phone' },
  { key: 'region', heading: 'Region' },
  { key: 'assigned_spoc_email', heading: 'SPOC Email' },
  { key: 'validation_proof_url', heading: 'Validation Proof', isUrl: true },
  { key: 'lead_stage', heading: 'Lead Stage' },
  { key: 'rejection_reason', heading: 'Rejection Reason', isRejectionReason: true },
  { key: 'contract_number', heading: 'Contract Number' },
  { key: 'contract_value', heading: 'Contract Value' },
  { key: 'site_type', heading: 'Site Type' },
  { key: 'invoice_attachment_url', heading: 'Invoice Attachment', isUrl: true },
  { key: 'b2c_revenue', heading: 'B2C Revenue' },
  { key: 'revenue_excel_url', heading: 'Revenue Excel', isUrl: true },
  { key: 'central_validated_at', heading: 'Central Validated At', isDate: true },
  { key: 'central_validated_by', heading: 'Central Validated By' },
  { key: 'ops_remarks', heading: 'Ops Remarks', fullWidth: true },
];

/** Base options for fusion-service `/api/file-upload/document`. `doc_type` is inferred per file (image vs document). */
export const FUSION_DOCUMENT_UPLOAD_OPTIONS = {
  service_name: 'fusion',
  is_public: true,
  is_view_only: true,
};
